import { useEffect, useRef } from "react";
import { apiRequest } from "src/async/apiUtils";

const INACTIVITY_THRESHOLD_MINUTES = 30;

export function useSessionResumeTracker({ workspace_id, group_id, page_id }) {
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    const sendSessionEvent = async () => {
      await apiRequest("POST", `/portal/users/track-session`, {
        body: {
          workspace_id,
          group_id,
          page_id,
        },
      });
    };

    const updateActivity = () => {
      const now = Date.now();
      const minutesSinceLast = (now - lastActivityRef.current) / (1000 * 60);
      if (minutesSinceLast > INACTIVITY_THRESHOLD_MINUTES) {
        // User has returned after inactivity → Send session resume
        sendSessionEvent();
      }

      lastActivityRef.current = now;
      localStorage.setItem("lastActivity", now.toString());
    };

    const loadFromStorage = () => {
      const stored = localStorage.getItem("lastActivity");
      if (stored) {
        lastActivityRef.current = parseInt(stored, 10);
      }
    };

    loadFromStorage();
    updateActivity(); // Track immediately on mount

    const events = ["mousemove", "scroll", "keydown", "click"];
    events.forEach((event) => window.addEventListener(event, updateActivity));

    return () => {
      events.forEach((event) => window.removeEventListener(event, updateActivity));
    };
  }, [workspace_id, group_id, page_id]);
}
